import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main'
    }, {
      path: '/forgot',
      name: 'forgot'
    }, {
      path: '/reset',
      name: 'reset'
    }, {
      path: '/redirect/:type',
      name: 'redirect'
    }, {
      path: '/attraction',
      name: 'attraction'
    }, {
      path: '/competitiveness',
      name: 'competitiveness'
    }, {
      path: '/toolattraction',
      name: 'toolattraction'
    }, {
      path: '/toolcompetitiveness',
      name: 'toolcompetitiveness'
    }, {
      path: '/admin',
      name: 'admin'
    }, {
      path: '/adminProductPrice',
      name: 'adminProductPrice'
    }, {
      path: '/adminReport',
      name: 'adminReport'
    }, {
      path: '/adminAccessLog',
      name: 'adminAccessLog'
    }, {
      path: '/report',
      name: 'report'
    }, {
      path: '/tutorial',
      name: 'tutorial'
    }, {
      path: '/productPrice',
      name: 'productPrice'
    }, {
      path: '/register',
      name: 'register',
      component: (resolve) => {
        require(['../pages/register.vue'], resolve)
      }
    }, {
      path: '/user',
      name: 'user',
      component: (resolve) => {
        require(['../pages/user.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js